import React, { Component } from "react";

class ReviewStep extends Component {
  getCampaignTypeName = (type) => {
    const types = {
      "promotional": "Promotional Campaign",
      "birthday": "Birthday Campaign",
      "anniversary": "Anniversary Campaign",
      "loyalty": "Loyalty Campaign",
      "winback": "Win-back Campaign",
      "custom": "Custom Campaign"
    };
    return types[type] || type;
  };

  getStoreNames = () => {
    const { formData } = this.props;
    if (formData.allStoresSelected) {
      return "All Stores";
    } else {
      return formData.associatedStores.map(store => store.label).join(", ");
    }
  };

  getMembershipName = () => {
    const { formData } = this.props;
    if (!formData.membershipSelected || !formData.membership) return "None";
    return formData.membership.Name;
  };

  styles = {
    container: {
      padding: '16px'
    },
    heading: {
      fontSize: '24px',
      fontWeight: 'bold',
      marginBottom: '24px'
    },
    gridContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '24px'
    },
    card: {
      border: '1px solid #e5e7eb',
      borderRadius: '8px',
      padding: '16px'
    },
    cardTitle: {
      fontWeight: '600',
      fontSize: '18px',
      marginBottom: '12px'
    },
    cardText: {
      marginBottom: '8px'
    },
    label: {
      fontWeight: '500'
    },
    fullWidthCard: {
      gridColumn: 'span 2',
      border: '1px solid #e5e7eb',
      borderRadius: '8px',
      padding: '16px'
    },
    subGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '16px'
    },
    successBox: {
      marginTop: '12px',
      padding: '12px',
      backgroundColor: '#f0fdf4',
      borderRadius: '8px'
    },
    successText: {
      color: '#15803d',
      fontWeight: '500',
      margin: 0
    },
    templateBox: {
      marginTop: '8px',
      backgroundColor: '#f3f4f6',
      padding: '12px',
      borderRadius: '8px'
    },
    templateText: {
      fontSize: '14px',
      margin: 0
    },
    infoBox: {
      marginTop: '24px',
      padding: '16px',
      backgroundColor: '#eff6ff',
      borderRadius: '8px'
    },
    infoTitle: {
      fontWeight: '600',
      color: '#1e40af',
      marginBottom: '8px'
    },
    infoText: {
      color: '#2563eb',
      margin: 0
    },
    marginTop2: {
      marginTop: '8px'
    },
    marginBottom0: {
      marginBottom: 0
    }
  };

  render() {
    const { formData, campaignType, totalCustomers } = this.props;

    return (
      <div style={this.styles.container}>
        <h2 style={this.styles.heading}>Review Campaign Details</h2>
        
        <div style={this.styles.gridContainer}>
          {/* Campaign Details */}
          <div style={this.styles.card}>
            <h3 style={this.styles.cardTitle}>Campaign Details</h3>
            <div>
              <p style={this.styles.cardText}>
                <span style={this.styles.label}>Name:</span> {formData.name}
              </p>
              <p style={this.styles.cardText}>
                <span style={this.styles.label}>Type:</span> {this.getCampaignTypeName(campaignType)}
              </p>
              <p style={this.styles.cardText}>
                <span style={this.styles.label}>Frequency:</span> {formData.type}
              </p>
              <p style={this.styles.cardText}>
                <span style={this.styles.label}>Start Date:</span> {formData.startDate}
              </p>
              {formData.type === "Recurring" && (
                <p style={this.styles.cardText}>
                  <span style={this.styles.label}>End Date:</span> {formData.endDate}
                </p>
              )}
              {formData.type === "One Time" && (
                <p style={this.styles.cardText}>
                  <span style={this.styles.label}>Time Slot:</span> {formData.slot}
                </p>
              )}
            </div>
          </div>

          {/* Store Details */}
          <div style={this.styles.card}>
            <h3 style={this.styles.cardTitle}>Store Details</h3>
            <p style={this.styles.marginBottom0}>
              <span style={this.styles.label}>Stores:</span> {this.getStoreNames()}
            </p>
          </div>

          {/* Customer Filters */}
          <div style={this.styles.fullWidthCard}>
            <h3 style={this.styles.cardTitle}>Customer Filters</h3>
            <div style={this.styles.subGrid}>
              <div>
                <p style={this.styles.cardText}>
                  <span style={this.styles.label}>Visit Frequency:</span> {formData.customerSelected ? `${formData.customerVisited} in ${formData.customerInDays} days` : "Not filtered"}
                </p>
                <p style={this.styles.cardText}>
                  <span style={this.styles.label}>Purchase Amount:</span> {formData.purchaseAmountSelected ? `${formData.purchaseAmountFrom} - ${formData.purchaseAmountTo}` : "Not filtered"}
                </p>
                <p style={this.styles.cardText}>
                  <span style={this.styles.label}>Membership:</span> {this.getMembershipName()}
                </p>
              </div>
              <div>
                <p style={this.styles.cardText}>
                  <span style={this.styles.label}>Gender:</span> {formData.customerGenderSelected ? formData.customerGender : "Not filtered"}
                </p>
                <p style={this.styles.cardText}>
                  <span style={this.styles.label}>Wallet Balance:</span> {formData.walletBalanceSelected ? `${formData.walletBalanceFrom} - ${formData.walletBalanceTo}` : "Not filtered"}
                </p>
                <p style={this.styles.cardText}>
                  <span style={this.styles.label}>Outstanding Amount:</span> {formData.outStandingAmtSelected ? `${formData.outStandingAmtFrom} - ${formData.outStandingAmtTo}` : "Not filtered"}
                </p>
              </div>
            </div>
            {totalCustomers > 0 && (
              <div style={this.styles.successBox}>
                <p style={this.styles.successText}>{totalCustomers} customers match your filters</p>
              </div>
            )}
          </div>

          {/* Message Details */}
          <div style={this.styles.card}>
            <h3 style={this.styles.cardTitle}>Message Details</h3>
            <p style={this.styles.cardText}>
              <span style={this.styles.label}>Channel:</span> {formData.campaignChannel}
            </p>
            {formData.enableSMS && formData.hasOwnProperty('smsTemplateID') && formData.smsTemplateID && (
              <div style={this.styles.marginTop2}>
                <span style={this.styles.label}>SMS Template:</span>
                <div style={this.styles.templateBox}>
                  <p style={this.styles.templateText}>{formData.smsTemplate}</p>
                </div>
              </div>
            )}
            {formData.enableWhatsapp && formData.hasOwnProperty('selectedWhatsappTemplate') && formData.selectedWhatsappTemplate && (
              <div style={this.styles.marginTop2}>
                <span style={this.styles.label}>WhatsApp Template:</span>
                <p style={{...this.styles.templateText, marginTop: '4px'}}>{formData.selectedWhatsappTemplate.templateName}</p>
              </div>
            )}
          </div>

          {/* Offer Details */}
          <div style={this.styles.card}>
            <h3 style={this.styles.cardTitle}>Offer Details</h3>
            <p style={this.styles.marginBottom0}>
              <span style={this.styles.label}>Associated Offer/Coupon:</span> {formData.offer || "None"}
            </p>
          </div>
        </div>

        <div style={this.styles.infoBox}>
          <h3 style={this.styles.infoTitle}>Ready to Launch!</h3>
          <p style={this.styles.infoText}>Review all the details above and click "Save Campaign" to launch your campaign.</p>
        </div>
      </div>
    );
  }
}

export default ReviewStep;